import { render, staticRenderFns } from "./AddBankPage.vue?vue&type=template&id=13fcc962&scoped=true&"
import script from "./AddBankPage.vue?vue&type=script&lang=js&"
export * from "./AddBankPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fcc962",
  null
  
)

export default component.exports